import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from '../../../lib/moment.js'
import shortid from 'shortid'
import get from 'lodash/get'
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from 'reactstrap'
import MoreOption from '../../../static/images/more_option_dots.svg'

export const DateHeaderMobile = (props) => {
  const activeTab = get(props, 'activeTab')
  const month = moment(get(props, 'month'))

  return (
    <Column>
      <Total />
      { activeTab === 2 && <Total>Total MDs</Total> }
      { get(props, 'weekdates', []).map((date) => {
        const isToday = date.isSame(moment(), 'day')
        return (
          <Cell
            key={ shortid() }
            isToday={ isToday }
            style={ {
              borderTopColor: '#ad191f',
              borderTopWidth: isToday ? 5 : 0,
              backgroundColor: date.month() !== month.month() ? '#EBEBEB' : '',
            } }
          >
            <Day
              isToday={ isToday }
              color={ date.month() !== month.month() ? '#a0a0a0' : 'black' }
              style={ { marginTop: isToday ? -5 : 0 } }
            >
              { date.format('dd') }
            </Day>
            <Date
              isToday={ isToday }
              color={ date.month() !== month.month() ? '#a0a0a0' : 'black' }
            >{ date.date() }</Date>
          </Cell>
        )
      }) }
      <Last>
        <Dropdown>
          <Delete tag='div'>
            <More />
          </Delete>
          <Menu tag='div'>
            <DeleteItem tag='div' onClick={ () => props.openInfo() }>Information</DeleteItem>
            <DeleteItem tag='div' onClick={ () => props.openRemark() }>Remark</DeleteItem>
            <DeleteItem tag='div' onClick={ () => props.openLegends() }>Legends</DeleteItem>
          </Menu>
        </Dropdown>
      </Last>
    </Column>
  )
}

export const SelectProjectHeader = (props) => {
  return (
    <Column>
      <Total>Total</Total>
      { get(props, 'weekdates', []).map(date => {
        const isToday = date.isSame(moment(), 'day')
        return (
          <Cell
            key={ shortid() }
            isToday={ isToday }
            style={ { borderTopColor: '#ad191f', borderTopWidth: isToday ? 5 : 0 } }
          >
            <Day
              isToday={ isToday }
              style={ { marginTop: isToday ? -5 : 0 } }
            >
              { date.format('dd') }
            </Day>
            <Date isToday={ isToday }>{ date.date() }</Date>
          </Cell>
        )
      }) }
    </Column>
  )
}

DateHeaderMobile.propTypes = {
  openInfo: PropTypes.func,
  openRemark: PropTypes.func,
  openLegends: PropTypes.func,
}
DateHeaderMobile.defaultProps = {
  openInfo: () => {},
  openRemark: () => {},
  openLegends: () => {},
}

const Dropdown = styled(UncontrolledDropdown)`
  margin-left: 5px
  margin-bottom: 10px;
  cursor: pointer;
  z-index: 2;
`
const Delete = styled(DropdownToggle)`
  font-size: 20px;
  text-align: center;
  height: 100%;
  color: #717171;
  margin-bottom: 0px;
`
const Menu = styled(DropdownMenu)`
  z-index: 99999;
`
const DeleteItem = styled(DropdownItem)`
  font-size: 12px;
  height: 30px;
`
const Column = styled.div`
  @media (max-width: 1199.98px) {
    display: none;
  }
  @media (max-width: 991.98px) {
    display: none;
  }
  @media (max-width: 575.98px) {
    height: 100%;
    background-color: #FFFFFF;
    flex: 1;
    overflow: visible;
    display: flex;
    flex-direction: row;
    border: solid #EAEAEA;
    border-width: 0px 1px 0px 0px;
    z-index: 1 !important;
  }
  @media (max-width: 767.98px) {
    height: 100%;
    background-color: #FFFFFF;
    flex: 1;
    overflow: visible;
    display: flex;
    flex-direction: row;
    border: solid #EAEAEA;
    border-width: 0px 1px 0px 0px;
    z-index: 1 !important;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const More = styled.div`
  background-image: url(${MoreOption});
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  margin: 5px;
  cursor: pointer;
`
const Cell = styled.div`
  font-family: 'Gotham' !important;
  font-size: 10px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: solid #EAEAEA;
  border-width: 0px 0.5px 0px 0.5px;
`
const Total = styled.span`
  width: 5%;
  margin-right: 2%;
  font-family: 'Gotham-Bold' !important;
  font-size: 10px;
  text-align: center;
  margin-top: 5px;
  margin-bottom: 10px;
`
const Last = styled.div`
  width: 10%;
  font-family: 'Gotham-Bold' !important;
  font-size: 10px;
  text-align: center;
  margin-top: 5px;
  margin-bottom: 10px;
  z-index: 2 !important;
`
const Date = styled.div`
  font-family: 'Gotham-Bold' !important;
  color: ${(props) => {
    if (props.isToday) return '#ad191f'
    return props.color
  }};
`
const Day = styled.div`
  font-family: 'Gotham' !important;
  color: ${(props) => {
    if (props.isToday) return '#ad191f'
    return props.color
  }};
`



// WEBPACK FOOTER //
// ./src/components/timesheet/helpers/header-mobile-approval.js